// extracted by css-extract-rspack-plugin
export default {"cls1":"NewsInteractionBar-cls1_-Ta","cls2":"NewsInteractionBar-cls2_OWx NewsInteractionBar-cls1_-Ta","variant-dense":"NewsInteractionBar-variant-dense_LBu"};